<div nz-row nzGutter="24" class="preview">
  <div nz-col nzXXl="16" nzLg="12" nzXs="12" class="content">
    <h3>{{ data && data.items[0].snippet.title }}</h3>
    <h4>{{ data && data.items[0].snippet.channelTitle }}</h4>
    <h5>{{ data && durationToString(data.items[0].contentDetails.duration) }}</h5>
    <div class="validation-mark">
      <ng-container *ngIf="data && isDurationValid(data.items[0].contentDetails.duration); else errorMessage">
        <img class="icon" src="./assets/images/check.svg">
        <span>تم التحقق منه</span>
      </ng-container>
      <ng-template #errorMessage>
        <i nz-icon nzType="close-circle" nzTheme="fill" class="icon error"></i>
        <span class="error">مدة مقطع الفيديو تزيد عن 3 دقائق</span>
      </ng-template>
    </div>
  </div>
  <div nz-col nzXXl="8" nzLg="12" nzXs="12" class="image">
    <a href="https://youtu.be/{{ data && data.items[0].id }}" target="_blank">
      <img src="{{ data && data.items[0].snippet.thumbnails.default.url }}">
      <i nz-icon nzType="play-circle" nzTheme="outline"></i>
    </a>
  </div>
</div>
